import { Button } from '@blueprint/button';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { CardWrapperProps, CarouselWrapperProps } from './Carousel.types';

export const CarouselWrapper = styled('div')<CarouselWrapperProps>(
    ({ peekingSlides, theme: { spacing } }) => css`
        position: relative;
        padding: 0;
        margin: ${peekingSlides ? '0 -1rem' : '0 -1rem 0 0'};
        ${CardWrapper} {
            padding-left: ${peekingSlides ? spacing['16px'] : 0};
            padding-right: ${peekingSlides ? 0 : spacing['16px']};
            &:last-child {
                margin-right: ${peekingSlides ? spacing['16px'] : 0};
            }
        }
        ${ButtonGroup} {
            padding-right: 1rem;
        }
    `
);

export const ButtonGroup = styled.div(
    ({ theme: { spacing } }) => css`
        margin: auto;
        position: relative;
        text-align: right;

        ${NavButton} {
            margin-right: ${spacing['8px']};
            &:last-child {
                margin-right: 0;
            }
        }
    `
);

export const NavButton = styled(Button)`
    min-width: 48px;
    &:disabled {
        background-color: transparent;
    }
`;

export const SlideWrapper = styled('div')(
    ({ theme: { spacing } }) => css`
        position: relative;
        height: auto;
        width: 100%;
        display: inline-block;
        white-space: nowrap;
        overflow-x: scroll;
        vertical-align: top;
        scrollbar-width: none;
        margin-bottom: ${spacing['24px']};
        &::-webkit-scrollbar {
            display: none;
        }
    `
);

export const CardWrapper = styled('li')<CardWrapperProps>(
    ({ width }) => css`
        width: ${width}%;
        white-space: normal;
        min-height: 1px;
        margin: 0;
        padding: 0;
        display: inline-block;
        vertical-align: top;
    `
);

export const Slider = styled.ul`
    margin: 0;
    padding: 0;
`;
